@if (settings.showTierListExplainer()) {
  <div class="info box reset-font" style="margin-bottom: 12px;">
    <div class="close-info-btn" (click)="hideExplainer()">✕</div>
    <h3 class="info-title">Explainer: <strong>Tier Lists, Economies & Tiering Modes</strong></h3>

    <div class="info-box-body">
      <app-content cid="explainer-tier-lists" contentType="tip" [conditions]="{ poe1: poe1, poe2: poe2 }"></app-content>
      <p><a class="remove-warning-link" (click)="hideExplainer()">(I understand, dismiss)</a></p>
    </div>
  </div>
}

@if (!divinationCardTab) {
  <div class="tier-list-info">
    <div class="tier-input">
      <div style="display: flex; flex-direction: row; gap: 12px; align-items: center; flex-wrap: wrap;">
        <span style="align-self: center;">Currency Types</span>
        <app-select class="inline" style="width: 200px" [searchable]="true" [disabled]="false" [(ngModel)]="currencyTypeSelection" (selectedValueChange)="onCurrencyTypeSelectionChange($event)">
          @for (mode of currencyTypePresetModes; track mode) {
            <app-option [value]="mode" [text]="mode"></app-option>
          }
          @for (type of currencyTypeSelectOptions; track type.type) {
            <app-option [value]="type.type" [text]="type.type" [imgUrl]="type.image ? imgPrefix + type.image : ''" [alt]="type.type" [width]="'16px'" [height]="'16px'">
            </app-option>
          }
        </app-select>
        @if (currencyTypeSelection === 'Custom') {
          <app-autocomplete class="inline currency-type-autocomplete"
            [options]="currencyTypeAutocompleteOptions"
            [showOptions]="true"
            [selectedValues]="customSelectedCurrencyTypes"
            (selectedValuesChange)="onCustomTypesChange($event)">
          </app-autocomplete>
        }
      </div>
    </div>

    <div class="tier-input tier-options">
      <div class="tier-values-toggle-buttons label-size-slider">
        <input type="range" min="0" max="4" [value]="tieringModeIndex" (input)="onTieringModeSliderChange($event)" />
        <span class="label-size-value">{{ tieringModeLabel }}</span>
        <button type="button" class="btn toggle-button toggle-buttom-equalizer" title="Configure Custom Tiering Mode" [disabled]="!isCustomTieringMode" (click)="openCustomTieringDialog()">
          <span class="icon icon-equalizer"></span>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="tier-list-info">
    <div class="tier-input">
      <input appGlobalShortcutFocus="f" placeholder="Search by name, text, area, boss or monster" type="text" class="search-filter form-control"
        [(ngModel)]="divinationCardFilter">

      <span class="regular-checkbox show-drop-info-toggle">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!settings.showDropInfo()" (click)="toggleShowDropInfo()"></button>
        </span>
        Show Drop Info instead of Flavour Text
      </span>
    </div>

    <div class="tier-input tier-options">
      <div class="tier-values-toggle-buttons label-size-slider">
        <input type="range" min="0" max="4" [value]="tieringModeIndex" (input)="onTieringModeSliderChange($event)" />
        <span class="label-size-value">{{ tieringModeLabel }}</span>
        <button type="button" class="btn toggle-button toggle-buttom-equalizer" [disabled]="!isCustomTieringMode" (click)="openCustomTieringDialog()">
          <span class="icon icon-equalizer"></span>
        </button>
      </div>
    </div>
  </div>
}

<div class="tier-list">
  @for (tierColumn of tierColumns; track $index) {
    <div class="tier-column">
      @for (tier of tierColumn; track tier.tier) {
        <div class="tier"
              (dragenter)="onDragEnter($event, tier)"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event, tier)"
              (drop)="onDrop($event, tier)"
              [class.drag-over]="tier.isDragOver">
          <app-tier-style [displayable]="tier.cosmetics" [allowedDisplayTypes]="[DisplayType.Custom]" [allowDisactivate]="false"
            [label]="tier.name" [isHeader]="true" [isTitle]="true" [isCurrency]="!divinationCardTab" [isDivinationCard]="divinationCardTab" [exampleName]="tier.exampleName"
            [styleDialogTitle]="tier.styleDialogTitle" (styleUpdated)="buildTierList()"></app-tier-style>
          @if (!filter.ssf) { <div class="tier-subtitle">{{ tier.priceLabel }} <img [src]="tier.priceBaseCurrencyImage ? imgPrefix + tier.priceBaseCurrencyImage : ''" [alt]="tier.priceBaseCurrency" class="base-type-image" width="18" height="18" loading="lazy"></div> }
          <div class="tier-item-types">
            @for (itemType of tier.itemTypes; track itemType.itemType) {
              <div class="tier-item-type">
                @if (!divinationCardTab) {
                  <div class="tier-item-type-title" [class.has-content-icon]="itemType.contentIcon">
                    <h4>
                      @if (itemType.contentIcon) {
                        <img class="tier-item-type-content-icon" [src]="imgPrefix + itemType.contentIcon" [alt]="itemType.itemType" width="24" height="24" loading="lazy" />
                      }
                      <span class="tier-item-type-label">
                        {{ itemType.itemType }}
                      </span>
                    </h4>
                  </div>
                }
                <div class="tier-item-type-body">
                  @for (baseType of itemType.baseTypes; track baseType.name) {
                    @if (filterDivinationCard(baseType)) {
                      <div class="tier-item-type-base-type" [class.no-drag]="baseType.hiddenByQuickFilter"
                        [class.tier-item-inactive]="!tier.cosmetics.displayOptions.active || !!tier.cosmetics.displayOptions.hidden">
                        @if (itemType.itemType === 'Divination Cards') {
                          <app-divcard-viewer
                            [name]="baseType.name"
                            [hideTooltip]="draggedItem?.name == baseType.name"
                            [showDropInfo]="settings.showDropInfo()"
                            [pinned]="pinnedDivinationCard === baseType.name"
                            [draggable]="!baseType.hiddenByQuickFilter"
                            (click)="onDivinationCardClick(baseType)"
                            (dragstart)="onDragStart($event, baseType)"
                            (dragend)="onDragEnd()"
                            [class.dragged]="draggedItem?.name === baseType.name"
                          ></app-divcard-viewer>
                        } @else {
                          <app-item-label
                            [baseType]="baseType.name"
                            [devHighlight]="isDevMode && baseType.noValue"
                            [image]="baseType.image"
                            [hideTooltip]="draggedItem?.name == baseType.name"
                            [draggable]="!baseType.hiddenByQuickFilter"
                            (dragstart)="onDragStart($event, baseType)"
                            (dragend)="onDragEnd()"
                            [class.dragged]="draggedItem?.name === baseType.name"
                            [displayLabel]="baseType.displayLabel"
                            [hiddenByQuickFilter]="baseType.hiddenByQuickFilter"
                            [manualTier]="baseType.manualTier"
                            [favouriteCurrencyAdjusted]="baseType.favouriteCurrencyAdjusted"
                          ></app-item-label>
                        }
                        @if (baseType.originalTier && baseType.originalTier !== tier.tier) {
                          <span class="original-tier" (click)="resetToOriginalTier(baseType)"
                            title="Reset to original {{ baseType.originalTier }}-tier">↻</span>
                        } @else {
                          @if (baseType.movedUp || baseType.movedDown) {
                            <app-tooltip-wrapper [right]="true" style="display: inline-block;">
                              @for (i of baseType.movedUpArray; track i) {
                                <span class="moved up">↑</span>
                              }
                              @for (i of baseType.movedDownArray; track i) {
                                <span class="moved down">↓</span>
                              }
                              <ng-template #tooltip>
                                <strong>{{ baseType.name }}</strong>
                                <br /><span class="normal-item-color">Previous value:</span> {{ baseType.previousValue }} ex <span [class]="baseType.previousTierColor">({{ baseType.previousTier }})</span>
                                <br /><span class="normal-item-color">Current value:</span> {{ baseType.value }} ex <span [class]="tier.tierColor">({{ tier.tier }})</span>
                                @for (i of baseType.movedUpArray; track i) {
                                  <span class="moved up">↑</span>
                                }
                                @for (i of baseType.movedDownArray; track i) {
                                  <span class="moved down">↓</span>
                                }
                              </ng-template>
                            </app-tooltip-wrapper>
                          }
                          @if (baseType.noValue) {
                            <app-tooltip-wrapper [right]="true" style="display: inline-block;">
                              <span class="uncertain-tier icon icon-notification"></span>
                              <ng-template #tooltip>No known value. Uncertain tier.</ng-template>
                            </app-tooltip-wrapper>
                          } @else {
                            <app-price-type-indicator [priceType]="baseType.priceType" [isUnique]="false" [disabled]="baseType.name === 'Exalted Orb'"></app-price-type-indicator>
                          }
                        }
                        @if (baseType.hiddenByQuickFilter) {
                          <app-tooltip-wrapper [right]="true" style="display: inline-block;">
                            <span class="hide-item-link quick-filter-lock" (click)="unhideFromQuickFilter(baseType, $event)">
                              <span class="icon icon-lock"></span>
                            </span>
                            <ng-template #tooltip>Hidden by Quick Filter. Click to unlock.</ng-template>
                          </app-tooltip-wrapper>
                        } @else if (baseType.tier !== Tier.FHidden) {
                          <span class="hide-item-link" (click)="hideItem(baseType)"
                            title="Hide item">
                            <span class="icon icon-eye-blocked"></span>
                          </span>
                        } @else {
                          <span class="hide-item-link" (click)="showItem(baseType)"
                            title="Always at least show item">
                            <span class="icon icon-eye"></span>
                          </span>
                        }
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

@if (showCustomTieringDialog) {
  @if (divinationCardTab) {
    <app-custom-div-card-tiering-mode-dialog
      [filter]="filter"
      (close)="closeCustomTieringDialog()">
    </app-custom-div-card-tiering-mode-dialog>
  } @else {
    <app-custom-currency-tiering-mode-dialog
      [filter]="filter"
      (close)="closeCustomTieringDialog()">
    </app-custom-currency-tiering-mode-dialog>
  }
}
